<template>
  <card-item card="item_post" :tabs="tabs" :activeTab="activeTab" :id="id">
  
  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          component: () => import("./Info"),
        },
        {
          title: "Контент",
          component: () => import("./Contents"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>